import cls from 'classnames';
import './index.scss';

export const Block = ({
    component: Component = 'div', className = '', color = 'light', children, square = false, padding = 'small',
}) => (
    <Component className={cls('item-block', `color-${color}`, square && 'square', `padding-${padding}`, className)}>
        {children}
    </Component>
);

export * from './BlockBorder';